import {
    useCallback,
} from 'react'

import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/LongTermLease/LongTermLeaseComment.requests'

const useRemoveTermLeaseComment = ({
    onSuccess,
}: { onSuccess?: () => void }) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessRemove,
        onError,
    } = useHandleStatusRequest({
        title: 'Comment was successfully removed',
        id: 'CommentRemoved',
        onSuccess,
    })

    const {
        mutate: deleteComment,
    } = useMutation({
        mutationFn: (id: number) => {
            return simpleApi({
                ...requests.archive({
                    id,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessRemove,
    })

    return useCallback((id: number) => {
        deleteComment(id)
    }, [deleteComment])
}

export default useRemoveTermLeaseComment
